import { useCreateProviderTag } from '../../api/useCreateProviderTag';
import { useGetProviderTags } from '../../api/useGetProviderTags';
import { ProviderTag } from '../../types';

export function useProviderTagPicker() {
  const { data: allTags = [], isLoading } = useGetProviderTags();
  const createTagMutation = useCreateProviderTag();

  async function handleCreateTag(name: string): Promise<ProviderTag | void> {
    const created = await createTagMutation.mutateAsync(name);
    return created;
  }

  return {
    allTags,
    isLoading,
    isCreating: createTagMutation.isPending,
    handleCreateTag,
  };
}
